// extracted by mini-css-extract-plugin
module.exports = {"menu":"menu___3GOmV"};